var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "495px",
        title: "提示",
        visible: _vm.visible,
        "close-on-click-modal": false,
        "before-close": _vm.closeDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", [
        _vm._v(
          " 该人员信息已存在" +
            _vm._s(_vm.errCode === "5145" ? "黑名单" : "简历库") +
            "，无法再新增，可点击“查看详情”了解该员工信息。 "
        ),
      ]),
      _c(
        "template",
        { staticClass: "dialog-footer", slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.closeDialog } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("查看详情")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }